/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

// libraries
import { connect } from 'react-redux';

// actions
import { createLabel } from 'state/actions/embedsState/embeds_status';
import { attachLabel, removeLabel } from 'state/actions/embedsState/embedManagementState/selected_embed_status'
import { displayModal } from '@insticator/insticator-ui'; // iui-utils

// component
import LabelAssignmentField from 'material/embeds/labelassignmentfield/labelassignmentfield';



/* ========== ~~~~~~~~~~ LABEL ASSIGNMENT FIELD : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState, sessionStatus }) => ({
    accountUUID: sessionStatus.accountUUID,
    labels: embedsState.embedsStatus.labels
});

// map actions
const mapDispatchToProps = dispatch => ({
    createLabel: (accountUUID, labelName, callback) => dispatch(createLabel(accountUUID, labelName, callback)),
    displayModal: (isVisible, contentToDisplay, showCloseButton) => dispatch(displayModal(isVisible, contentToDisplay, showCloseButton))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LabelAssignmentField);
